export default __webpack_public_path__ + "static/media/full_TheSilverSorceress.4bdfc737.jpg";